import React, {useEffect, useRef} from 'react';
import Chart from 'chart.js/auto';
import useStatisticsSummary from "../chartDetails/handler/useStatisticsSummary";
import Paper from "@mui/material/Paper";
import {useStyles} from "./BasicChart.css";

export default function BasicChart({chartData, chartId}) {

    const classes = useStyles()

    // Hook for showing additional information when a chart element is clicked
    const {handleStatisticsSummary} = useStatisticsSummary()

    // Reference to the generated chart object
    const chartRef = useRef(null)

    useEffect(() => {

        // Get the chart canvas
        let chartCtx = document.getElementById(chartId)?.getContext('2d');

        // Destroy the chart if existing (this is necessary, because the chart gets reloaded on filter change)
        chartRef.current?.destroy()

        // Create chart instance and register click listener (to show details in a popup)
        chartRef.current = new Chart(chartCtx, chartData)
        document.getElementById(chartId)?.addEventListener("click", (evt) => onChartElementClick(evt, chartRef), false)

    }, [chartData])

    // Handler for for getting a chart summary in case of clicking on a chart element (bar, point of line)
    const onChartElementClick = (evt, chart) => {

        // Grab the required information from the dataset constructed in the backend
        const points = chart.current.getElementsAtEventForMode(evt, 'nearest', {intersect: true}, true);

        if (points.length) {
            const firstPoint = points[0];
            let value = chart.current.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];

            // Handles the showing of the extra information
            handleStatisticsSummary(value)
        }
    }

    // Render the chart in a canvas
    return <Paper className={classes.chartPaper}>
        <canvas id={chartId}></canvas>
    </Paper>
}